/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EditMissingInfoFollowUpDraftRequest
 */
export interface EditMissingInfoFollowUpDraftRequest {
    /**
     * 
     */
    draft: string;
    /**
     * 
     */
    expected_draft_revision: string;
}

/**
 * Check if a given object implements the EditMissingInfoFollowUpDraftRequest interface.
 */
export function instanceOfEditMissingInfoFollowUpDraftRequest(value: object): value is EditMissingInfoFollowUpDraftRequest {
    if (!('draft' in value) || value['draft'] === undefined) return false;
    if (!('expected_draft_revision' in value) || value['expected_draft_revision'] === undefined) return false;
    return true;
}

export function EditMissingInfoFollowUpDraftRequestFromJSON(json: any): EditMissingInfoFollowUpDraftRequest {
    return EditMissingInfoFollowUpDraftRequestFromJSONTyped(json, false);
}

export function EditMissingInfoFollowUpDraftRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMissingInfoFollowUpDraftRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'draft': json['draft'],
        'expected_draft_revision': json['expected_draft_revision'],
    };
}

export function EditMissingInfoFollowUpDraftRequestToJSON(json: any): EditMissingInfoFollowUpDraftRequest {
    return EditMissingInfoFollowUpDraftRequestToJSONTyped(json, false);
}

export function EditMissingInfoFollowUpDraftRequestToJSONTyped(value?: EditMissingInfoFollowUpDraftRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'draft': value['draft'],
        'expected_draft_revision': value['expected_draft_revision'],
    };
}

